import { ResourceName } from '../resource-name';

export const ResumeGate = {
  resource: ResourceName.resume,
  actions: {
    saveResume: 'save-resume',
  },
};

export type ResumeGateActionTypes = {
  saveResume: {
    request: SaveResumeRequest;
    response: undefined;
  };
};

export interface SaveResumeRequest {
  resumeId: string;
  workspaceId: string;
  fileName: string;
  base64Content: string;
  contentType: string;
}
